import { ToastContainer } from "react-toastify";
import { Router } from "./routes";
import AppProvider from "./hook";
import { MustChangePasswordModal } from "./components/must-change-password-modal";
import "react-toastify/dist/ReactToastify.css";

export function App() {
  return (
    <div className="min-h-screen bg-surface-subtle dark:bg-zinc-950">
      <AppProvider>
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
          containerId="toast"
        />
        <Router />
        <MustChangePasswordModal />
      </AppProvider>
    </div>
  );
}
